// extracted by mini-css-extract-plugin
module.exports = {"attrib":"Entry_attrib__1Q3bC"};